import { QueryParameterSchema } from './types';

export const statusFilterQueryFilter: QueryParameterSchema<'status'> = {
  getDefaultValue: () => [],
  getValue: ({ queryParameters }) => queryParameters.status,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    status: (urlSearchParams.get('filter[status]') || '').split(','),
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[status]': value.join(',') }),
  toSearchQuery: ({ value, staticProps }) => {
    if (value.length === 0) return {};
    const values = value.flatMap((groupCode) => staticProps.referenceData.applicationStatusGroups[groupCode].statuses);
    return { 'filter[status]': values };
  },
  sanitize: ({ value, staticProps }) => {
    const {
      referenceData: { applicationStatusGroups },
    } = staticProps;
    return { status: value.filter((s) => !!s && !!applicationStatusGroups[s]) };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { applicationStatusGroups },
    },
  }) => {
    return value.map((status) => ({
      filterKey: 'status',
      key: `status_${status}`,
      label: applicationStatusGroups[status].label,
      value: status,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { status: value.filter((item) => item !== removedValue) };
  },
};
